export default __webpack_public_path__ + "static/media/hometop.0b044eaa.png";